import React from "react";
import "../Ecocalendar/Ecocalendar.css"; 
import { useTranslation } from "../../../utils/hooks/translateHook.js";



const Ecocalender = () => {
  
  const t = useTranslation();

  return (
    <div className="eco-tool">
      <h2 className="eco-title">📅 {t('economicCalendar')}</h2>
      <div className="eco-calendar-box">
        <p style={{ fontStyle: "italic" }}>  </p>
         <div style={{ Width: '1024px', margin: '0 auto', position: 'relative' }}>
      <iframe
        src="https://sslecal2.investing.com?columns=exc_flags,exc_currency,exc_importance,exc_actual,exc_forecast,exc_previous&features=datepicker,timezone&countries=25,32,6,37,72,22,17,39,14,10,35,43,56,36,110,11,26,12,4,5&calType=week&timeZone=8&lang=1"
        maxWidth="1024"
        width="90%"
        height="467"
        frameBorder="0"
        allowTransparency="true"
        marginWidth="0"
        marginHeight="0"
        title="Investing.com Economic Calendar"
      ></iframe>
      <div
        style={{
          fontFamily: 'Arial, Helvetica, sans-serif',
          fontSize: '11px',
          color: '#333333',
          textAlign: 'center',
          marginTop: '5px',
        }}
      >

        .
      </div>
    </div>
      </div>
    </div>
  );
};

export default Ecocalender;
